// extracted by mini-css-extract-plugin
module.exports = {"top":"Spacer_top__akuuQ","topMenu":"Spacer_topMenu__wQ9tp","bottom":"Spacer_bottom__3hWWd","bottomAbove":"Spacer_bottomAbove__35UFn"};